function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useState, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import AlertCard from "./AlertCard";
import { positions, groupBy, types } from "./options";
import useShowAndRemove from "./useShowAndRemove";
const AlertInstance = /*#__PURE__*/forwardRef((props, ref) => {
  const [alerts, setAlerts] = useState([]);
  const {
    show,
    remove
  } = useShowAndRemove(props, setAlerts);
  useImperativeHandle(ref, () => ({
    add: alert => {
      show(alert);
    },
    delete: key => {
      remove(key);
    }
  }));
  const {
    prefixClassName
  } = props;
  const alertsByPosition = groupBy(alerts, alert => alert.position);
  return Object.values(positions).map(position => /*#__PURE__*/React.createElement("div", {
    className: `${prefixClassName} ${position}`,
    style: props.containerStyle,
    key: position
  }, alertsByPosition[position] ? alertsByPosition[position].map(alert => {
    return /*#__PURE__*/React.createElement(AlertCard, _extends({
      prefixClassName: prefixClassName
    }, alert, {
      key: alert.key,
      onClose: () => remove(alert.key),
      position: position,
      hasTransition: true
    }), alert.message);
  }) : null));
});
AlertInstance.displayName = "AlertInstance";
AlertInstance.defaultProps = {
  prefixClassName: "tui-alert",
  position: positions.TOP_RIGHT,
  containerStyle: {}
};
AlertInstance.propTypes = {
  prefixClassName: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  position: PropTypes.oneOf(Object.values(positions)),
  containerStyle: PropTypes.object
};
const Alert = (() => {
  let instance;
  let innerAlert;
  function configureAlert() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    instance = document.createElement("div");
    document.body.appendChild(instance);
    function ref(alert) {
      if (!innerAlert) {
        innerAlert = alert;
      }
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(AlertInstance, _extends({}, props, {
      ref: ref
    })), instance);
  }
  if (!instance) {
    configureAlert();
  }
  return {
    config: properties => {
      if (!instance) {
        configureAlert(properties);
      }
    },
    show: alertProps => {
      innerAlert.add({
        ...alertProps,
        type: types.DEFAULT
      });
    },
    success: alertProps => {
      innerAlert.add({
        ...alertProps,
        message: alertProps.message,
        type: types.SUCCESS
      });
    },
    error: alertProps => {
      innerAlert.add({
        ...alertProps,
        message: alertProps.message,
        type: types.ERROR
      });
    },
    info: alertProps => {
      innerAlert.add({
        ...alertProps,
        message: alertProps.message,
        type: types.INFO
      });
    },
    warning: alertProps => {
      innerAlert.add({
        ...alertProps,
        message: alertProps.message,
        type: types.WARNING
      });
    },
    remove: key => {
      innerAlert.delete(key);
    },
    destroy: () => {
      ReactDOM.unmountComponentAtNode(instance);
      instance.parentNode.removeChild(instance);
      instance = null;
      innerAlert = null;
    }
  };
})();
export default Alert;
//# sourceMappingURL=Alert.js.map